import {combineReducers} from 'redux'
import {localizeReducer} from 'react-localize-redux';
import layoutReducer from '../../features/Layout/reducers';
import errorReducer from '../../features/Errors/reducers';
import authReducer from '../../features/Auth/reducers';
import contentReducer from '../../features/Content/reducers';
import contactReducer from '../../features/Contact/reducers';
import coursesReducer from '../../features/Courses/reducers';
import schoolsReducer from '../../features/Schools/reducers';
import newsReducer from '../../features/News/reducers';
import dashboardReducer from '../../features/Dashboard/reducers';

export default combineReducers({
    localize: localizeReducer,
    layout: layoutReducer,
    errors: errorReducer,
    auth: authReducer,
    content: contentReducer,
    contact: contactReducer,
    courses: coursesReducer,
    schools: schoolsReducer,
    news: newsReducer,
    dashboard: dashboardReducer,
});



// WEBPACK FOOTER //
// ./src/app/redux/reducers.js